"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExtendAppointmentCubby = void 0;
require("antd/lib/spin/style");
var _spin = _interopRequireDefault(require("antd/lib/spin"));
var _react = _interopRequireDefault(require("react"));
var _core = require("@monument/core");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _ScreenTitle = require("./components/ScreenTitle");
var _CubbyFooter = _interopRequireDefault(require("./CubbyFooter"));
var _lodash = require("lodash");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var ExtendAppointmentCubby = function ExtendAppointmentCubby(_ref) {
  var booking = _ref.booking,
    onClose = _ref.onClose,
    onSuccess = _ref.onSuccess;
  return /*#__PURE__*/_react.default.createElement(_core.Cubby, {
    visible: !!booking,
    overlayStyles: "fixed top-0 right-0 w-screen h-screen z-cubby-overlay",
    cubbyStyles: "fixed bottom-0 right-0 h-[calc(100vh-theme(spacing.app-header-height))] w-[476px] z-cubby",
    onClose: onClose
  }, booking && /*#__PURE__*/_react.default.createElement(ExtendAppointmentCubbyContent, {
    booking: booking,
    onClose: onClose,
    onSuccess: onSuccess
  }));
};
exports.ExtendAppointmentCubby = ExtendAppointmentCubby;
var ExtendAppointmentCubbyContent = function ExtendAppointmentCubbyContent(_ref2) {
  var booking = _ref2.booking,
    onClose = _ref2.onClose,
    _onSuccess = _ref2.onSuccess;
  var _useAuth = (0, _core.useAuth)(),
    user = _useAuth.user;
  var startsAt = booking.startsAt,
    intervalFrequency = booking.intervalFrequency,
    bookingId = booking.id;
  var _useRequest = (0, _core.useRequest)((0, _core.getExtendBookingConflictsUrl)(user.accountId, bookingId)),
    _useRequest$data = _useRequest.data,
    conflicts = _useRequest$data === void 0 ? [] : _useRequest$data,
    loadingConflicts = _useRequest.loading;
  var _useRequest2 = (0, _core.useRequest)({
      url: (0, _core.getExtendBookingUrl)(user.accountId, bookingId),
      method: 'put'
    }, {
      manual: true,
      onSuccess: function onSuccess() {
        _core.toast.success({
          title: 'Successfully changed booking duration!'
        });
        _onSuccess();
        onClose();
      }
    }),
    extendBooking = _useRequest2.runAsync,
    loadingExtendBooking = _useRequest2.loading;
  var details = intervalFrequency ? [(0, _momentTimezone.default)(startsAt).format("[".concat((0, _lodash.capitalize)((0, _core.formatRecurringFrequencyPrefix)(intervalFrequency)), "] dddd [at] h:mm a"))] : [(0, _momentTimezone.default)(startsAt).format('dddd, MMMM Do, YYYY, h:mm a')];
  return /*#__PURE__*/_react.default.createElement(_spin.default, {
    spinning: loadingConflicts || loadingExtendBooking
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "px-[24px] pt-[36px] pb-[24px] flex flex-col gap-y-[24px]"
  }, /*#__PURE__*/_react.default.createElement(_ScreenTitle.ScreenTitle, null, "Change ", intervalFrequency ? 'all appointments' : 'appointment', " to one hour"), /*#__PURE__*/_react.default.createElement("ul", {
    className: "tw-label-regular text-grey-75 pl-[24px] mb-0 flex flex-col gap-y-[8px]"
  }, details.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: item
    }, item);
  })), !(0, _lodash.isEmpty)(conflicts) && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_core.Alert, {
    type: _core.AlertTypeEnum.Alert
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-light text-black"
  }, "Changing the duration conflicts with these existing Monument appointments."), /*#__PURE__*/_react.default.createElement("p", {
    className: "tw-body-light text-black"
  }, "Please cancel or reschedule them first."), /*#__PURE__*/_react.default.createElement("ul", {
    className: "tw-body-regular text-black pl-[24px] mt-[8px] mb-0 flex flex-col gap-y-[8px]"
  }, conflicts.map(function (item) {
    return /*#__PURE__*/_react.default.createElement("li", {
      key: item.id
    }, (0, _momentTimezone.default)(item.startsAt).format('dddd, MMMM Do, YYYY, h:mm a'));
  })))), /*#__PURE__*/_react.default.createElement(_CubbyFooter.default, {
    actionDisabled: loadingConflicts || !(0, _lodash.isEmpty)(conflicts),
    actionText: "Confirm",
    onAction: extendBooking,
    onCancel: onClose
  })));
};